module.exports = __webpack_public_path__ + "img/Monte_Kope_61.837088ed.jpg";